import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getPagination = (state) => get(state, 'asset_level.list.pagination', {});
export const getFilters = (state) => get(state, 'asset_level.list.filters', {});

export const getAssetLevelIds = (state) => get(state, 'asset_level.list.result.asset_level', []);
export const getAssetLevel = (state) => get(state, 'asset_level.list.entities.asset_level', []);

export const getIsLoading = (state) => get(state, 'asset_level.list.isLoading', false);
export const getNeedFetch = (state) => get(state, 'asset_level.list.needFetch', false);

export const getIsFetching = (state) => get(state, 'asset_level.form.isFetching', false);
export const getIsFetchingConfig = (state) =>
  get(state, 'asset_level.form.isFetchingConfig', false);
export const getIsSaving = (state) => get(state, 'asset_level.form.isSaving', false);
export const getEditing = (state) => get(state, 'asset_level.form.editing', false);

export const getVisibleAssetLevel = createSelector(
  [getAssetLevelIds, getAssetLevel],
  (ids, asset_level) =>
    ids.map((id) => asset_level[id]).filter((asset_level) => !asset_level.deleted)
);



// WEBPACK FOOTER //
// src/modules/secured/modules/asset_level/selectors/asset_level_selectors.js